import {
  AfterViewInit,
  Directive,
  ElementRef,
  OnDestroy,
  inject,
} from '@angular/core';
import { IFrameComponent, iframeResizer } from 'iframe-resizer';
@Directive({ selector: '[iframeResizer]' })
export class IframeResizerDirective implements AfterViewInit, OnDestroy {
  elemRef = inject(ElementRef);

  // Allow iframes to grow to fit their content. How to use:
  // <iframe iframeResizer [src]="srcUrl | safeUrl" scrolling="no" frameborder="0" width="100%"></iframe>
  component: IFrameComponent;

  allowedDomains: string[] = [
    'https://staging-app.agrigateone.com',
    'https://agrigateone.metabaseapp.com',
    'localhost',
    'https://app.agrigateone.com',
  ];

  constructor() {}

  ngAfterViewInit() {
    // config options:
    // https://github.com/davidjbradshaw/iframe-resizer/blob/master/docs/parent_page/options.md
    const components = iframeResizer(
      {
        autoResize: true,
        bodyBackground: 'transparent',
        checkOrigin: this.allowedDomains,
        heightCalculationMethod: 'bodyOffset', // good enough, no flicker
        log: false, // toggle on for debugging
        sizeHeight: true,
        sizeWidth: false, // set width to full width on HTML element
        resizeFrom: 'parent',
        tolerance: 20, // only resize if size changes by 20px (thumb suck)
      },
      this.elemRef.nativeElement,
    );

    // iframe-resizer returns an array of components
    // save component ref so that we can close it later
    this.component = components[0];
  }

  ngOnDestroy(): void {
    if (this.component?.iFrameResizer) {
      this.component.iFrameResizer.close();
    }
  }
}
